import { Layout } from 'antd'
import styled from 'styled-components'
import logoSmall from '../../assets/forpy-logo-small.svg'

const { Header } = Layout

export const HeaderForpy = styled(Header)`
    position: absolute;
    width: 100%;
    z-index: 98;
    top:  0px;
    left: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 0px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;

    @media (min-width: 760px) {
        justify-content: flex-end;
    }

    a {
        margin: 0 6px;
        transition: var(--transition);
        color: var(--blue-darker);

        &:hover {
            opacity: 0.7;
            transition: var(--transition);
        }
        
        .logo {
            aspect-ratio: 131 / 35.54;
            width: 100px;
        }

    }


    .page-title {
        color: var(--blue-darker);
        font-size: 1.5rem;
        text-align: center;
        width: 100%;

        @media (min-width: 760px) {
            display: none;
        }
    }
`

export const LogoSmall = styled.div`
    width: 26px;
    aspect-ratio: 74 / 54;
    background-image: url(${logoSmall});
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: transparent;
    margin-left: 12px;
    
    @media (max-width: 760px) {
        position: absolute;
        right: 16px;
    }
`
